export default __webpack_public_path__ + "static/media/data_unavailable.06ee7bc9.webp";